export interface PaginationMeta {
  page: number;
  pageSize: number;
  totalPages: number;
  totalElements: number;
}

export const readPaginationHeaders = (
  headers: Record<string, unknown>,
  fallback: { page: number; pageSize: number; itemsLength: number }
): PaginationMeta => {
  const getHeaderNumber = (key: string, defaultValue: number): number => {
    const raw = headers[key.toLowerCase()] ?? headers[key];
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : defaultValue;
  };

  return {
    page: getHeaderNumber("x-page", fallback.page),
    pageSize: getHeaderNumber("x-page-size", fallback.pageSize),
    totalPages: Math.max(1, getHeaderNumber("x-total-pages", 1)),
    totalElements: getHeaderNumber("x-total-elements", fallback.itemsLength),
  };
};

export const toApiPage = (pageIndex: number): number => pageIndex + 1;

export const toPageIndex = (apiPage: number): number => Math.max(0, apiPage - 1);
